import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash/fp';
import { requestEvents } from 'actions/inPersonTraining/eventsDashboard/events';
import { Spinner } from 'ui';
import Loadable from 'components/shared/loadable';
import { isLoadingEvents } from 'selectors/inPersonTraining/eventsDashboard';
import UpNextEvent from './UpNextEvent';
import EventList from './EventList';
import EmptyState from './EmptyState';

class EventDashboard extends Component {
  componentDidMount() {
    this.props.requestEvents();
  }

  render() {
    const { loading, hasAvailableEvents } = this.props;
    return (
      <div className="EventDashboard">
        <h1 className="EventDashboard-heading ff-ss">
          {t('in_person_training.events_dashboard.heading')}
        </h1>
        {loading && (
          <div className="EventDashboard-loading">
            <Spinner className="mr-16" />
            <span>{t('common.loading')}</span>
          </div>
        )}
        <Loadable loading={loading}>
          <UpNextEvent />
          {hasAvailableEvents && <EventList />}
          {!loading && !hasAvailableEvents && <EmptyState />}
        </Loadable>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: isLoadingEvents(state),
  hasAvailableEvents:
    state.events.upcomingEvents.collection.length > 0 ||
    state.events.pastEvents.collection.length > 0 ||
    !isEmpty(state.events.nextAttendingEvent) ||
    state.events.upcomingOpenEvents.collection.length > 0,
});

const mapDispatchToProps = {
  requestEvents,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventDashboard);
